module.exports = __webpack_public_path__ + "static/media/pla_clear_angel_cut_straw3.c5dad644.png";